import { useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { SiteDto } from '../dto/SiteDto';
import { useTranslation } from 'react-i18next';

export function useSitesCreateForm(): UseFormReturn<SiteDto> {
  const { t } = useTranslation();

  return useForm<SiteDto>({
    resolver: useMemo(
      () =>
        yupResolver(
          yup.object().shape({
            name: yup.string().label(t('Name')).required(),
          }),
        ),
      [t],
    ) as any,
  });
}
